import store from "../storeConfig";

export function loadGenericNotification(message) {
    store.dispatch({
        type: "LOAD_GENERIC_NOTIFICATION",
        newMessage: message
    })
}

export function disableGenericNotification() {
    store.dispatch({
        type: "UNLOAD_GENERIC_NOTIFICATION"
    })
}

export function enableTransactionFilterModal() {
    store.dispatch({
        type: "TRANSACTION_FILTER_MODAL_CHANGE",
        newState: true
    })
}

export function disableTransactionFilterModal() {
    store.dispatch({
        type: "TRANSACTION_FILTER_MODAL_CHANGE",
        newState: false
    })
}

export function enableCharityThanksModal() {
    store.dispatch({
        type: "CHARITY_THANKS_MODAL_CHANGE",
        newState: true
    })
}

export function disableCharityThanksModal() {
    store.dispatch({
        type: "CHARITY_THANKS_MODAL_CHANGE",
        newState: false
    })
}

export function enableDebugMode() {
    store.dispatch({
        type: "ENABLE_DEBUG_MODE"
    })
}

export function disableDebugMode() {
    store.dispatch({
        type: "DISABLE_DEBUG_MODE"
    })
}

export function disableAdBanner() {
    store.dispatch({
        type: "DISABLE_ADBANNER"
    })
}